import Testimonials from './Testimonials'
export * from './types'
export * from './mappers'
export default Testimonials
